import React from "react";
import { Link } from "gatsby"
import "../../assets/scss/components/_catalog.scss"

const Catalog = ({categories}) => (
  <div className={'catalog'}>
    <h1 className={'title'}>Have a look<br /> at our catalogs</h1>

    <div className={'blocks grid-1 grid-md-2 grid-lg-3'}>
      {categories.map(({name, description}) => (
        <Link to={description} target={'_blank'} className={'block'}><p>{name}</p></Link>
      ))}
    </div>
  </div>
)

export default Catalog
